import { Button } from "react-aria-components";
import { globalSubmittingSignal } from "../../Layout";
import { useEffect, useState } from "react";
import { SingularUpperCase } from "../../../../../helpers/EntityNameHelper";
import { modalSignal } from "../../../Modal/ModalContainer";
import RemoveModal from "../../../Modal/RemoveModal";
import { AccountStatusSmartEnum } from "../../../../../enums/Domain/AccountStatusSmartEnum";

interface IDeleteAccountActionProps {
    data: any
}

export default function DeleteAccountAction(props: IDeleteAccountActionProps) {
    const { data } = props;
    const [alreadyRequestedDeletion, setAlreadyRequestedDeletion] = useState<boolean | undefined>()

    useEffect(() => {
        setAlreadyRequestedDeletion(data.status.value === AccountStatusSmartEnum.PendingDeletion.value);
    }, [data])

    async function handleRemove() {
        setAlreadyRequestedDeletion(true)
    }

    function handleConfirmBlock() {
        modalSignal.value = <RemoveModal
            heading={`Remove ${SingularUpperCase(data.entityName)}`}
            textLabel={`To confirm, enter account name exactly as shown below`}
            expectedConfirmationValue={data.name}
            removeEntity={data.entityName}
            removeId={data.id}
            information="This will remove the account and all associated data (there is a 7 day grace period, after which all data will be permanently removed). You will be emailed a download with details of the deleted data. If you wish to cancel this request, please contact support@remote.online within the grace period."
            ContinueFunc={async () => { await handleRemove() }} />
    }

    return alreadyRequestedDeletion !== undefined ?
        <Button isDisabled={globalSubmittingSignal.value.isBusy || alreadyRequestedDeletion} className="button button--small button--primary button--primary--destructive button--with-icon" onPress={handleConfirmBlock}>
            <p className="button-text">Delete</p>
        </Button> : <></>
}